import{jsx as e}from"react/jsx-runtime";import t from"react-select";export{components}from"react-select";import o from"react-select/creatable";import{X as n}from"lucide-react";import r from"tailwind-styled-components";const i=r.span`
  [font-size:.5em]
  bg-gray-400
  cursor-pointer
  flex-shrink-0
  h-4
  inline-flex
  items-center
  justify-center
  leading-none
  p-[2px]
  rounded-full
  text-white
  transition-opacity
  w-4
`,a=({innerProps:t})=>e(i,{...t,title:"Clear",children:e(n,{})}),l=n=>{const r=["allowCreateWhileLoading","createOptionPosition","formatCreateLabel","isValidNewOption","getNewOptionData","onCreateOption"],i=Object.keys(n).some((e=>r.includes(e)));let l=t;i&&(l=o);return e(l,{...n,classNamePrefix:n.classNamePrefix??"select",components:{ClearIndicator:a,...n.components||{}},hideSelectedOptions:n.hideSelectedOptions??!0,isClearable:n.allowClear??!0,onChange:(e,t)=>{"function"==typeof n.onChange&&n.onChange(e,t)},placeholder:n.placeholder??"Select an option"})};export{l as default};
